const CodeRoute = () => {
  return <div>Code</div>;
};

export default CodeRoute;
